export class ImpostazioneFtp
{
  parametro: string;
  valore: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/impostazione-ftp.ts